module.exports = __webpack_public_path__ + "public/img/book_2.315c872d.png";